/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TChatsRemoveFromSpamDesktopModel,
  IChatsRemoveFromSpamDesktopRequest,
  IMappers,
  IChatsRemoveFromSpamDesktopResponse,
  IChatsRemoveFromSpamDesktopResponseError,
  TChatsRemoveFromSpamDesktopResponse,
} from './types';

const defaultConfig: TChatsRemoveFromSpamDesktopModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'chats',
  pathApi: '/v1/chats/remove-from-spam-desktop/',
  hostType: 'api',
} as TChatsRemoveFromSpamDesktopModel;

function createChatsRemoveFromSpamDesktopModel(
  parameters: IChatsRemoveFromSpamDesktopRequest,
): TChatsRemoveFromSpamDesktopModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IChatsRemoveFromSpamDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IChatsRemoveFromSpamDesktopRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchChatsRemoveFromSpamDesktop<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IChatsRemoveFromSpamDesktopOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TChatsRemoveFromSpamDesktopResponse
> {
  const { response, statusCode } = await httpApi.fetch(createChatsRemoveFromSpamDesktopModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IChatsRemoveFromSpamDesktopResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IChatsRemoveFromSpamDesktopResponseError);
    }
  }

  return { response, statusCode } as TChatsRemoveFromSpamDesktopResponse;
}

export { defaultConfig, createChatsRemoveFromSpamDesktopModel, fetchChatsRemoveFromSpamDesktop };
